const style = {}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/BillingTable/style/ColorBlind/transaction.js